import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'vota-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  encapsulation:ViewEncapsulation.None
})
export class FooterComponent {
  @Input() isDetailFooter: boolean = false;
  year = new Date().getFullYear()
}
